import React, { useCallback, useContext } from 'react'
import { ButtonCta, ButtonCtaProps, ButtonStatus } from '../../../ui-lib/button'
import { gnarSpec } from '../../../../lib/tracking/gnar'
import { PageContext } from '../../../../contexts/page-context'
import { trackExtensionInstall } from '../../../../lib/tracking/google-tag-manager/events'
import { UserService } from '../../../../lib/services/user'
import { goToSignUp } from '../../../../lib/utils/navigate'
import { useUserService, useBrowserService } from '../../../../lib/hooks'
import { waitGnar } from '../../../../lib/utils/promise'
import { CtaTrackingProps } from '../types'

export interface ExtensionInstallButtonProps extends Omit<ButtonCtaProps, 'onClick'>, CtaTrackingProps {
  onClick?: () => void
  installUrl: string
  asLink?: boolean
  preventRedirectInCurrentTab?: boolean
}

function redirectToSignup(userService: UserService) {
  if (window.GR_EXTENSION_ID) {
    goToSignUp(userService, { install: 'true' })
  } else {
    goToSignUp(userService)
  }
}

export const ExtensionInstallButton: React.FC<ExtensionInstallButtonProps> = (props) => {
  const { pageId, slug } = useContext(PageContext)
  const userService = useUserService()
  const browserService = useBrowserService()
  const { onClick, installUrl, asLink, placement, placementInternalName, preventRedirectInCurrentTab, ...restProps } =
    props

  const onClickHandler = useCallback(async () => {
    await waitGnar(gnarSpec.addExtensionButtonClick(pageId, slug, placement, placementInternalName))
    trackExtensionInstall(placement)
    onClick?.()
    if (!preventRedirectInCurrentTab) {
      setTimeout(() => redirectToSignup(userService), browserService.isFirefox ? 1000 : 0)
    }
  }, [
    preventRedirectInCurrentTab,
    pageId,
    slug,
    placement,
    placementInternalName,
    onClick,
    userService,
    browserService,
  ])

  return asLink ? (
    <ButtonCta as="a" href="" status={ButtonStatus.Active} {...restProps} onClick={onClickHandler}>
      {restProps.text}
    </ButtonCta>
  ) : (
    <ButtonCta status={ButtonStatus.Active} {...restProps} onClick={onClickHandler} />
  )
}
